/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Public_BioInputs */

const cs_settings_profile_public_bio = /** @type {(inputs: Settings_Profile_Public_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejné bio (CS)`)
};

const en_settings_profile_public_bio = /** @type {(inputs: Settings_Profile_Public_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public bio (CS)`)
};

/**
* | output |
* | --- |
* | "Public bio (CS)" |
*
* @param {Settings_Profile_Public_BioInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public_bio = /** @type {((inputs?: Settings_Profile_Public_BioInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Public_BioInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public_bio(inputs)
	return cs_settings_profile_public_bio(inputs)
});